import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import Notfound from './pages/Notfound';
import Uploadfile from './pages/Uploadfile';

function App() {
  return (
    <Routes>
      <Route exact path='/' element={<Home/>}></Route>
      <Route exact path='/upload' element={<Uploadfile/>}></Route>
      <Route path='/inicio' element={<Dashboard/>}></Route>
      <Route exact path='*' element={<Notfound/>}></Route>
    </Routes>
  );
}

export default App;
